// Shared copy for the public (logged-out) pages: homepage, FAQ, pricing, about.
// Keep fee numbers here so every page says the same thing.

export const PLATFORM_FEE_PERCENT = 30;
export const PRO_PAYOUT_PERCENT = 100 - PLATFORM_FEE_PERCENT;

// Plain-text Q&As. Rendered on /auth/faq (and a few on the homepage) and
// emitted as FAQPage schema, so the visible text and the schema always match.
export const OBJECTION_FAQS = [
  {
    id: "fee",
    q: "What does Bite Logr take?",
    a: `You set your own monthly subscription price. Your followers pay you through Bite Logr. We keep ${PLATFORM_FEE_PERCENT}% - you keep ${PRO_PAYOUT_PERCENT}%, paid out monthly by direct deposit. Founding Anglers pay zero platform fees for life.`,
  },
  {
    id: "find",
    q: "How do I find pros on my water?",
    a: "After you register, the Anglers page suggests pros you can follow. Pros also share their Bite Logr profile link on their own social media, so you can follow a pro you already know straight from their link.",
  },
  {
    id: "payments",
    q: "How do payments and cancelling work?",
    a: "Subscription payments are processed by Stripe. Followers can cancel a subscription anytime from their account. Pros are paid monthly by direct deposit.",
  },
  {
    id: "who",
    q: "Who runs Bite Logr?",
    a: "Bite Logr is built by a small team of anglers. Read our story on the About page, or message us on Facebook with any question.",
  },
];

// Social proof. Fill these with REAL data only - each block renders nothing
// while empty, so no placeholder ever ships to the live page.
//
// TODO(owner): collect one-line quotes from your first pros and subscribers
// (first name, photo with permission, role like "Bass guide, Lake Fork", and a
// specific outcome like a first subscription payment or a better day out).
// Example shape: { name: "", role: "", quote: "", photo: require("...") }
export const TESTIMONIALS = [];

// TODO(owner): replace with a real count pulled from the app database,
// e.g. { pros: 12, waters: 8 }. Leave null to hide the proof strip.
export const USAGE_PROOF = null;

// TODO(owner): founder block on /auth/about. Renders only when name and story
// are filled in. Photo: drop a file in src/assets/img/ and require() it here.
export const FOUNDER = {
  name: "",
  photo: null,
  story: "",
  location: "",
  linkedin: "",
  x: "",
};

export const FACEBOOK_URL =
  "https://www.facebook.com/profile.php?id=61553952532799";
export const APPLE_URL = "https://apps.apple.com/us/app/bite-logr/id6737280925";
export const ANDROID_URL =
  "https://play.google.com/store/apps/details?id=com.mlehmann.BiteLogr";
